<template>
    <div v-show="isActive"><slot></slot></div>
</template>
<script>
export default {

    props: {
        id: {
            required: true,
        },
        name: {required: true},
        selected: {
            default: false
        },
        cssClass: {
            type: String,
            required: false,
            default: ''
        }
    },

    data() {
        return {
            isActive: this.selected
        };
    },

    mounted(){
        const hashString = window.location.hash;
        if (hashString) {
            let tab = hashString.substr(1, hashString.length);
            if (this.id.toLowerCase().replace(/ /g, '-') == tab) {
                eventBus.$emit('select-tab', tab)
                this.isActive = true
            }
        }
    },

    computed: {
        href() {
            return '#' + this.id.toLowerCase().replace(/ /g, '-');
        },

        style(){
            return this.isActive ? 'active ' + this.cssClass : '' + this.cssClass
        }
    },
}
</script>
